<ng-container *transloco="let t">
  @if (race) {
    <div class="race">
      <div class="race-header d-flex upper-section-background justify-content-between">
        <div class="d-flex">
          <div class="lengths-wrapper">
            {{ race?.length ? (race?.length | raceLengthFormat:translocoService.getActiveLang()) : '-' }}
          </div>
          <div class="name">
            <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                                 [siLabel]="race?.nameSlo" [defaultLanguage]="event?.defaultLanguage"
                                 [languages]="languages"/>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <div
            class="type-label trim-text d-flex align-items-center sport-label">
            {{ race?.sport ? t("app.common.sports." + race?.sport) : '' }}
          </div>
        </div>

      </div>
      <div class="race-info d-flex">
        <div>
          <div class="badge"
               [ngClass]="{'black': status === LiveItemStatus.FINISHED, 'green': status === LiveItemStatus.IN_PROGRESS, 'hidden': status === LiveItemStatus.TO_BE_STARTED}">
            {{ t("live.results.status." + status) }}
          </div>
        </div>
        <div class="race-details d-flex justify-content-between">
          <div class="wrapper">
            <div class="item border-item">
              <div> {{ t("event.item.start") }}:</div>
              <div class="fw-semibold color-primary"> {{
                  race.raceStart | localizedDate:"HH:mm"
                }}
              </div>
            </div>
            <div class="item">
              <div class="hide"> {{ t("event.item.date") }}:</div>
              <div class="fw-semibold color-primary">
                {{
                  race.raceStart | localizedDate:"shortDate"
                }}
              </div>
            </div>

          </div>
          <div class="buttons">
            <app-rounded-button [label]="t('live.results.see.all')" (onClick)="goToRaceLiveResultsPage()"
                                [btnClass]="'rounded-button--red-outline fixed-height'"
            />

            <div class="btn-horizontal-spacer"></div>
            <app-rounded-button [label]="t('live.results.see.big.screen')" (onClick)="goToRaceLiveResultsPage(true)"
                                [btnClass]="'rounded-button--black-outline fixed-height'"/>

          </div>

        </div>

      </div>
      <div class="small-screen-buttons">
        <app-rounded-button [label]="t('live.results.see.all')" (onClick)="goToRaceLiveResultsPage()"
                            [btnClass]="'rounded-button--red-outline fixed-height'"
        />

        <div class="btn-horizontal-spacer"></div>
        <app-rounded-button [label]="t('live.results.see.big.screen')" (onClick)="goToRaceLiveResultsPage(true)"
                            [btnClass]="'rounded-button--black-outline fixed-height'"/>

      </div>


    </div>
  }
</ng-container>
